import {
  AppointmentReducerState,
  AppointmentTypeSelection,
  AppointmentTypeSelectionNullObject,
  GetAppointment_V1Query,
  GetBlocker_V1Query,
  Option,
} from '@lichtblick/types';

import { formatName } from './formatName';

export const appointmentToAppointmentForm = (
  appointment: GetAppointment_V1Query['getAppointment_V1']['data'],
): AppointmentReducerState => {
  const parseDate = (value?: string | null) => {
    if (!value) {
      return undefined;
    }

    const parsed = new Date(value);

    return Number.isNaN(parsed.getTime()) ? undefined : parsed;
  };

  const endDate = parseDate(appointment?.appointment?.endDateUtc);
  const startDate = parseDate(appointment?.appointment?.startDateUtc);

  const initialAppointment: AppointmentReducerState = {
    workOrder: appointment?.appointment?.workOrder?.id ?? -1,
    appointmentType:
      appointment?.appointment?.workflowDefinition?.id !== undefined
        ? { id: appointment.appointment.workflowDefinition.id, kind: 'appointment' }
        : AppointmentTypeSelectionNullObject,
    branch: appointment?.appointment?.branchOffice?.id ?? -1,
    isBinding: appointment?.appointment?.isBinding === true,
    note: appointment?.appointment?.comment ?? '',
    people: appointment?.appointment?.constructedByCraftsmen
      ? appointment?.appointment?.constructedByCraftsmen.map(({ craftsman }) => ({
          label: craftsman ? formatName(craftsman) : '',
          value: craftsman?.id.toString(),
        }))
      : [],
    teams: appointment?.appointment?.constructedByTeams
      ? appointment?.appointment?.constructedByTeams.map(({ team }) => ({
          label: team?.name ?? '',
          value: team?.id.toString(),
        }))
      : [],
    startDate: startDate ? new Date(startDate) : undefined,
    endDate: endDate ? new Date(endDate) : undefined,
    partner: appointment?.appointment?.partnerCompanies?.length
      ? appointment.appointment.partnerCompanies[appointment.appointment.partnerCompanies.length - 1]?.id
      : undefined,
    createNewWorkflowInstance: false,
  };

  return initialAppointment;
};

export const blockerToAppointment = (
  blocker: GetBlocker_V1Query['getBlocker_V1']['data'],
  appointmentTypeOptions: Option<AppointmentTypeSelection>[],
): GetAppointment_V1Query['getAppointment_V1']['data'] | null => {
  if (!blocker) {
    return null;
  }

  const workflowDef = appointmentTypeOptions.find(
    (type) => type.label.toLowerCase() === blocker?.reason?.title?.toLowerCase(),
  );
  const typeValue = workflowDef?.value;
  const typeId = typeof typeValue === 'object' && typeValue !== null ? typeValue.id : -1;

  return {
    __typename: 'GetAppointmentPayloadModel',
    appointment: {
      __typename: 'GetAppointmentAppointmentPayloadModel',
      isBinding: false,
      comment: blocker?.comment,
      id: blocker?.id ?? -1,
      type: blocker?.reason?.title,
      startDateUtc: blocker?.startAtUtc,
      endDateUtc: blocker?.endAtUtc,
      constructedByTeams: blocker?.teams?.map((team) => ({ id: team.id, team: team })),
      constructedByCraftsmen: blocker?.users?.map((craftsman) => ({ id: craftsman.id, craftsman: craftsman })),
      workflowDefinition: {
        id: typeId,
        name: workflowDef?.label,
      },
      branchOffice: blocker?.branchOffice,
      partnerCompanies: blocker?.partnerCompanies,
    },
  };
};

export const getTime = (dateString: string) => {
  const date = new Date(dateString);

  const hours = date.getHours();
  const minutes = date.getMinutes();

  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
};
